import { SET_DASHBOARD_REFETCH } from 'actions';

export default function setDashboardRefetch() {
  return {
    type: SET_DASHBOARD_REFETCH,
  };
}
